import { motion } from "framer-motion";

const LOGOS = [
    { name: "Shopify", slug: "shopify" },
    { name: "Upwork", slug: "upwork" },
    { name: "React", slug: "react" },
    { name: "Next.js", slug: "nextdotjs" },
    { name: "Node.js", slug: "nodedotjs" },
    { name: "PHP", slug: "php" },
    { name: "WordPress", slug: "wordpress" },
    { name: "JavaScript", slug: "javascript" },
    { name: "HTML5", slug: "html5" },
];

export default function HeroLogoCloud() {
    return (
        <motion.div
            initial={{ opacity: 0, y: 32 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.85, ease: [0.22, 1, 0.36, 1] }}
            data-testid="hero-logo-cloud"
            className="lg:col-span-5"
        >
            <div className="rounded-3xl border border-slate-200 bg-white/75 p-6 shadow-card backdrop-blur-md sm:p-8">
                <div className="flex items-center justify-between">
                    <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.25em] text-slate-500">
                        Stack & Platforms
                    </p>
                    <span className="relative flex h-2 w-2">
                        <span className="absolute inline-flex h-full w-full animate-ping-soft rounded-full bg-brand" />
                        <span className="relative inline-flex h-2 w-2 rounded-full bg-brand" />
                    </span>
                </div>
                <div className="mt-6 grid grid-cols-3 gap-3">
                    {LOGOS.map((logo, i) => (
                        <motion.div
                            key={logo.slug}
                            initial={{ opacity: 0, scale: 0.85 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5, delay: 1 + i * 0.07, ease: [0.22, 1, 0.36, 1] }}
                            data-testid={`hero-logo-${logo.slug}`}
                            className="group flex aspect-square flex-col items-center justify-center gap-2.5 rounded-2xl border border-slate-200 bg-white transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1 hover:border-brand/40 hover:shadow-hover"
                        >
                            <img
                                src={`https://cdn.simpleicons.org/${logo.slug}`}
                                alt={`${logo.name} logo`}
                                loading="lazy"
                                className="h-8 w-8 transition-transform duration-300 group-hover:scale-110 sm:h-9 sm:w-9"
                            />
                            <span className="font-mono text-[9px] font-medium uppercase tracking-[0.14em] text-slate-400 transition-colors duration-300 group-hover:text-slate-600">
                                {logo.name}
                            </span>
                        </motion.div>
                    ))}
                </div>
                <div className="mt-6 flex items-center gap-4 border-t border-slate-100 pt-5">
                    <img
                        src="/brands/shopify-select-partner.png"
                        alt="Shopify Select Partner"
                        loading="lazy"
                        className="h-10 w-auto"
                    />
                    <p className="text-xs leading-relaxed text-slate-500">
                        Shopify Select Partner building stores for brands worldwide.
                    </p>
                </div>
            </div>
        </motion.div>
    );
}
